import { createI18n } from 'vue-i18n';
import messages from 'vue@/i18n/en.js';

const deepmerge = require('deepmerge');

const languageOverrideCache = {};
const loadedLanguages = ['en'];

class LanguageCache {
    constructor() {
        this.strings = {'en':{}};
        this.i18n = createI18n({
            fallbackLocale: 'en',
            locale: 'en',
            messages,


            // Override missing to be able to send fallback text, to prevent getting translaiton key as output.
            // For example $t('foo.bar') = foo.bar, $t('foo.bar', { fallback: 'barfoo' }) = barfoo
            missing: (...args) => {
                const [,,,opts] = args;
                if (opts.length === 0) {
                    return args;
                }

                return Object.keys(opts[0]).includes('fallback') ? opts[0].fallback : args;
            }
        });

        const locale = window.locale || 'en';

        this._ready = (locale !== 'en')
            ? this.loadLanguageAsync(locale)
            : this.loadOverrides(locale, window.langOverride, messages.en);

        if (locale !== 'en') {
            this.loadLanguageAsync(locale);
        } else {
            this.loadOverrides(locale, window.langOverride, messages.en);
        }
    }

    ready() {
        return this._ready || Promise.resolve(true);
    }

    setI18nLanguage(lang) {
        this.i18n.global.locale = lang;
        if (!this.strings[lang] || Object.keys(languageOverrideCache).length > 0) {
            this.strings[lang] = {};
        }
        // axios.defaults.headers.common['Accept-Language'] = lang;
        document.querySelector('html').setAttribute('lang', lang);
        return lang;
    }

    // let loadedOverrides = {};
    // async function loadOverrideAsync(override) {
    //     return import(/* webpackChunkName: "lang-[request]" */ `vue@/i18n/${override}.js`).then((messages) => {
    //         loadedOverrides[override] = messages;
    //     });
    // }

    loadLanguageAsync(lang) {
        // If the same language
        if (this.i18n.global.locale === lang) {
            return Promise.resolve(this.setI18nLanguage(lang));
        }

        // If the language was already loaded
        if (loadedLanguages.includes(lang)) {
            return Promise.resolve(this.setI18nLanguage(lang));
        }

        // If the language hasn't been loaded yet
        return import(/* webpackChunkName: "lang-[request]" */ `vue@/i18n/${lang}.js`).then(async (messages) => {
            await this.loadOverrides(lang, window.langOverride, messages.default[lang]);
            loadedLanguages.push(lang);
            return true;
        });
    }

    async loadOverrides(lang, langOverride, msg) {
        let translations = msg;
        if (langOverride) {
            if (!languageOverrideCache[langOverride]) {
                const override = await import(
                    /* webpackChunkName: "lang-[request]" */
                    `vue@/i18n/${langOverride}.js`
                );

                languageOverrideCache[langOverride] = override.default;
            }

            if (languageOverrideCache[langOverride][lang]) {
                translations = deepmerge(translations, languageOverrideCache[langOverride][lang]);
            }
        }

        this.i18n.global.setLocaleMessage(lang, translations);
        this.setI18nLanguage(lang);

        return translations;
    }

    get(key) {
        if (key in this.strings[this.i18n.global.locale]) {
            return this.strings[this.i18n.global.locale][key];
        }

        const value = this.i18n.global.t(key);// , this.i18n.locale, this.i18n._getMessages());
        this.strings[this.i18n.global.locale][key] = value;

        return value;
    }

    $t(key, choice) {
        return this.i18n.global.t(key, choice);
        // var values = [],
        //     len = arguments.length - 1;
        // while (len-- > 0) values[len] = arguments[len + 1];
        // return this.i18n._t.apply(this.i18n, [key, this.i18n.locale, this.i18n._getMessages(), this].concat(values));
    }

    $tc(key, choice) {
        return this.i18n.global.tc(key, choice);
        // var values = [],
        //     len = arguments.length - 2;
        // while (len-- > 0) values[len] = arguments[len + 2];
        // return this.i18n._tc.apply(
        //     this.i18n,
        //     [key, this.i18n.locale, this.i18n._getMessages(), this, choice].concat(values),
        // );
    }
}

export const languageCache = new LanguageCache();
